module.exports = __webpack_public_path__ + "static/media/meduvada.f54e9d5f.jpg";